export default { options: { label: 'Timetables Edit' } }
